var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftNav ft14"},[_c('ul',{staticClass:"fColor1"},_vm._l((_vm.array),function(item,index){return _c('li',{class:index == _vm.curActive ? 'active' :'',on:{"click":function($event){_vm.goto(index,item.page)}}},[_c('span',[_vm._v(_vm._s(item.text))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf381d6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/c2c/leftc2c.vue
// module id = null
// module chunks = 